export const categories = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-01',
    imageQuery: 'Minimalist white sneakers on clean cream background, modern product photography, soft natural lighting, elegant composition, high-end ecommerce style, fresh and airy aesthetic, subtle shadows, editorial fashion product shot',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-02',
    imageQuery: 'Premium quality grey hoodie displayed on light beige background, soft studio lighting, clean minimalist product photography, contemporary fashion aesthetic, relaxed folded presentation, high-end casual wear catalog style',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-03',
    imageQuery: 'Classic white cotton t-shirt on warm cream backdrop, soft natural daylight, minimal shadow product photography, clean and fresh aesthetic, premium basic apparel presentation, modern fashion catalog style',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-04',
    imageQuery: 'Stylish olive green bomber jacket displayed on light neutral background, soft directional lighting, modern product photography, clean composition, premium outerwear aesthetic, editorial fashion presentation',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-05',
    imageQuery: 'Well-fitted beige chino pants on light cream background, soft natural lighting, minimal product photography, clean and fresh aesthetic, modern casual wear presentation, refined simplicity',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-06',
    imageQuery: 'Classic baseball cap in warm sand color on clean beige backdrop, soft studio lighting, minimal product photography, contemporary streetwear aesthetic, simple elegant presentation, high-quality accessory catalog style',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-07',
    imageQuery: 'Coordinated matching tracksuit set in soft neutral tones on cream background, soft natural lighting, clean product photography, modern athleisure aesthetic, elegant folded presentation, lifestyle fashion catalog',
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-08',
    imageQuery: 'Premium cotton underwear set in soft pastel tones on light beige background, gentle studio lighting, tasteful minimal product photography, clean fresh aesthetic, high-quality essentials catalog style',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-09',
    imageQuery: 'Athletic sports jersey in deep forest green on warm cream backdrop, soft natural lighting, clean product photography, modern sportswear aesthetic, elegant presentation, premium athletic apparel catalog',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-10',
    imageQuery: 'Collection of elegant fashion accessories including watch and bracelet on light beige surface, soft natural daylight, minimal product photography, clean sophisticated aesthetic, luxury accessory flat lay presentation',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-11',
    imageQuery: 'Premium leather tote bag in warm cognac brown on cream background, soft studio lighting, clean product photography, modern minimalist aesthetic, elegant luxury accessory presentation, refined simplicity',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-12',
    imageQuery: 'Classic leather belt with brushed metal buckle on light beige backdrop, soft natural lighting, minimal product photography, clean and fresh aesthetic, refined accessory presentation, premium quality catalog style',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-13',
    imageQuery: 'Elegant glass perfume bottle with minimal design on warm cream background, soft diffused lighting, luxury product photography, clean sophisticated aesthetic, premium fragrance catalog presentation, subtle reflections',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-14',
    imageQuery: 'Diverse collection of lifestyle products neatly arranged on light beige surface, soft natural daylight, clean product photography, modern eclectic aesthetic, curated flat lay presentation, fresh and inviting composition',
  },
];